import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Axios client wrapper that returns the response's data mapped into an Observable
 *
 * @example ClientRequest.get<YourDto>('/your/uri').subscribe({ next: (response) => {LoggerService.log(response)},})
 */
// TODO: Try to use the same AuthClientRequest in a common folder... 'cause it's duplicated in custom-view-bff folder right now...
class AuthClientRequest {
  static get<T = any>(url: string, config?: AxiosRequestConfig): Observable<T> {
    return from(axios.get<T, AxiosResponse<T>>(url, config)).pipe(
      map((response) => response.data),
    );
  }

  static post<T = any>(
    url: string,
    data: any,
    config: AxiosRequestConfig,
  ): Observable<T> {
    return from(axios.post<T, AxiosResponse<T>>(url, data, config)).pipe(
      map((response) => response.data),
    );
  }

  static patch<T = any>(
    url: string,
    data: any,
    config: AxiosRequestConfig,
  ): Observable<T> {
    return from(axios.patch<T, AxiosResponse<T>>(url, data, config)).pipe(
      map((response) => response.data),
    );
  }
}

export default AuthClientRequest;
